import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Panel, PanelContent, PanelHeader } from "../../shared/Panel";
import {
	getFidelities,
	getMarketAnalysis,
	getOffers,
	getRankByOfferId,
	getRankPriceByFidelityAndMiles,
	getPricesByFidelityAndMiles
} from "../shared/requests-api";
import RankingOffer from "../components/ranking/RankingOffer";
import RankingAnalyze from "../components/ranking/RankingAnalyze";
import RankingSimulator from "../components/ranking/RankingSimulator";
import RankingRankingTable from "../components/ranking/RankingRankingTable";
import { viewRanking, refreshOffers, isNewUser } from "../actions";
import { getUserToken } from "../shared/utils";

let currentId = undefined;
class RankingPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fidelitiesLoading: false,
			analyzeLoading: false,
			simulatorLoading: false,
			fidelities: [],
			analyze: [],
			simulator: {},
			milesQuant: 0,
			tableRanking: {}
		};
	}

	componentDidMount() {
		const { data, loading, rankingId, viewRanking, fidelities } = this.props;

		if (rankingId) {
			viewRanking(undefined); // limpar
			this.getAllFn(rankingId);
		} else {
			this.getAllFn(6); // primeiro da lista
		}

		if (!loading && !data) {
			this.props.refreshOffers();
		} else if (data && data.offers && data.offers.length) {
			this.setState({ allOffers: data.offers });
		}
	}

	componentWillReceiveProps(nextProps) {
		const { data, error } = nextProps;

		if (error) {
			this.props.isNewUser(true);
		} else if (data && data.offers && data.offers.length) {
			this.setState({ allOffers: data.offers });
		}
	}

	// Busca as ofertas já cadastradas para o simulador de preços.
	// CASO SIM: Exibe a oferta e o ranking dela SE o status for 2
	// CASO NÃO: Exibr a opção de cadastrar uma oferta para essa cia.
	getOffersFn = id => {
		this.setState({
			simulatorLoading: true,
			simulator: {},
			tableRanking: {}
		});
		getOffers(getUserToken(), id)
			.then(responseOffers => {
				if (id != currentId) return;
				let offers = responseOffers.data.offers.filter(offerMap => {
					return (
						(offerMap.status == 2 || offerMap.status == 3 || offerMap.status == 7) &&
						offerMap.quant > 0 &&
						// considerar inativa quando a quantidade atual de milhas for menor que o limite
						// feito por maicon e rafa, de acordo com o palácio
						offerMap.quant >= offerMap.fidelity.valMinMiles &&
						!offerMap.invalidRank // flag pra nao exibir o ranking em determinados substatus
					);
				});

				if (offers.length > 0) {
					let quant = offers[0].quant;

					if (quant < offers[0].fidelity.valMinMiles) {
						quant = offers[0].fidelity.valMinMiles;
					} else if (quant > 150000) {
						quant = 150000;
					}

					this.setState({
						tableRanking: offers[0],
						milesQuant: quant
					});

					let simulator = {
						...offers[0]
					};

					getPricesByFidelityAndMiles(simulator.fidelity.id, simulator.quant)
						.then(responsePrice => {
							if (id != currentId) return;

							simulator.fidelity.maxPrice = responsePrice.data.maxPrice;
							simulator.fidelity.minPrice = responsePrice.data.minPrice;

							this.setState({
								simulatorLoading: false,
								simulator: simulator
							});
						})
						.catch(resp => {
							if (id != currentId) return;

							this.setState({
								simulatorLoading: false,
								simulator: simulator
							});
						});
				} else {
					this.setState({
						simulatorLoading: false,
						milesQuant: 0,
						tableRanking: {}
					});
				}
			})
			.catch(err => {
				if (id != currentId) return;
				this.setState({
					simulatorLoading: false
				});
			});
	};

	// Busca as analises do mercado para hoje, -3, -7 e -30 dias.
	getMarketAnalysisFn = (id, mobileData) => {
		this.setState({
			selected: id,
			selectSelected: !!mobileData ? mobileData : this.state.selectSelected,
			analyzeLoading: true,
			analyze: []
		});

		getMarketAnalysis(null, id)
			.then(response => {
				if (id != currentId) return;
				this.setState({
					analyzeLoading: false,
					analyze: response.data
				});
			})
			.catch(err => {
				if (id != currentId) return;
				this.setState({
					analyzeLoading: false,
					analyze: []
				});
			});
	};

	// Busca os programas de fidelidades nascionais
	getFidelitiesFn = () => {
		this.setState({
			fidelitiesLoading: true
		});
		getFidelities(null, 1)
			.then(response => {
				let airlines = response.data;

				this.setState({
					fidelitiesLoading: false,
					fidelities: airlines
				});
			})
			.catch(err => {
				this.setState({
					fidelitiesLoading: false
				});
			});
	};

	getAllFn = (id, mobileData = null) => {
		currentId = id;
		this.getMarketAnalysisFn(id, mobileData);
		this.getOffersFn(id);
	};

	componentWillMount() {
		this.getFidelitiesFn();
		this.getAllFn(this.state.selected);
	}

	render() {
		return (
			<div className="offers-ranking-page">
				<Panel className="offers-ranking-page__container">
					<PanelHeader className="offers-ranking-page__panel-header">
						<RankingOffer
							loading={this.state.fidelitiesLoading}
							fidelities={this.state.fidelities}
							select={(id, mobileData) => this.getAllFn(id, mobileData)}
							selectSelected={this.state.selectSelected}
							selected={this.state.selected}
						/>
					</PanelHeader>

					<PanelContent>
						<RankingAnalyze loading={this.state.analyzeLoading} analyze={this.state.analyze} />
						<RankingSimulator
							loading={this.state.simulatorLoading}
							simulator={this.state.simulator}
							selected={this.state.selected}
						/>
						{Object.keys(this.state.tableRanking).length > 0 ? (
							<RankingRankingTable
								fidelityId={this.state.selected}
								simulator={this.state.tableRanking}
								quant={this.state.milesQuant}
							/>
						) : (
							<Fragment />
						)}
					</PanelContent>
				</Panel>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	rankingId: state.offers.rankingId,
	data: state.offers.data,
	loading: state.offers.loading,
	error: state.offers.error
});

const mapDispatchToProps = dispatch => {
	return {
		isNewUser: newUser => dispatch(isNewUser(newUser)),
		viewRanking: id => dispatch(viewRanking(id)),
		refreshOffers: () => dispatch(refreshOffers())
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RankingPage);
